export default "__VITE_ASSET__m7ltd09E__"